<table class="ui inverted table selectable">
  <thead>
    <th>Created By</th>
    <th>Bounty Type</th>
    <th>Status</th>
    <th>Reward</th>
    <th>Ends at</th>
    <th>Claims</th>
    <th>Winner</th>
  </thead>
  <tbody>
    <tr *ngFor="let bounty of bounties" [routerLink]="['/bounties/' + bounty.id]"
      (mousedown)="onRowMouseDown($event, bounty)" (mouseup)="onRowMouseUp($event, bounty)">
      <td>
        <app-user-label [user]="bounty.owner"></app-user-label>
      </td>
      <td>
        <div class="ui label" [ngClass]="typeLabelClass(bounty)">
          {{ bounty.type }}
        </div>
      </td>
      <td>
        <div class="ui label" [ngClass]="statusColors[bounty.status]">{{
          bounty.status }}</div>
      </td>
      <td>
        <i class="small money bill green alternate icon"></i>
        {{ bounty.reward / 100 | currency }}
      </td>
      <td>
        {{ bounty.humanReadableTimeLeft }}
      </td>
      <td>
        {{ bounty.claimsCount }}
      </td>
      <td>
        <span *ngIf="!bounty.winningUser">-</span>
        <app-user-label *ngIf="bounty.winningUser" [user]="bounty.winningUser"></app-user-label>
      </td>
    </tr>
  </tbody>
</table>
